import React, { PropsWithChildren } from 'react';

export const DataGridSection: React.FC<PropsWithChildren> = (props) => {
  return (
    <div style={{ backgroundColor: 'white', padding: '0.625rem 0' }}>
      <div className="container-fluid">{props.children}</div>
    </div>
  );
};
